import React from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis } from '../../../Visualisation/components'
import { formatGraphData, getAxisDomain } from '../../../Visualisation/helpers'
import { GraphComponentPropsNew } from '../../../Visualisation/types'
import { ChartName } from '../../types'

const ContactsPerItemChart: React.FC<GraphComponentPropsNew> = ({ data, graphHeight, unit }) => {
  const formattedData = formatGraphData(ChartName.cost, undefined, data, value => Number(value))
  const domain = getAxisDomain(formattedData, ChartName.cost)

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <AreaChart data={formattedData} margin={{ left: 0 }}>
        <defs>
          <linearGradient id="color-cr" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#3A64F8" stopOpacity={0.2} />
            <stop offset="1" stopColor="#3A64F8" stopOpacity={0} />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: 'three', chartType: 'line' })}
        {YAxis({ dataKey: ChartName.cost, unit: unit, domain })}
        <CartesianGrid stroke="#CED8FD" strokeDasharray="5 5" />
        {ChartTooltip({ cursor: { stroke: '##3A64F8', strokeDasharray: '5 5' } })}
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey={ChartName.cost}
          stroke="#3A64F8"
          fill="url(#color-cr)"
          unit={unit}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default ContactsPerItemChart
